import React from 'react'
import { useEffect } from 'react';
import { useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Search from '../Search';
import { getKelas, updateStateKelas } from '../../features/kelasSlice';
import { updateClassSiswa } from '../../features/siswaSlice';
import { useState } from 'react';

function ModalRole({ onClose }) {
    const { loadingKelas, search, searchedKelas } = useSelector(
        (state) => state.kelas
    );
    const dispatch = useDispatch()
    const [modalOpen, setModalOpen] = useState(false);
    const modalRef = useRef(null);

    useEffect(() => {
        dispatch(getKelas());
    }, []);

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (modalRef.current && !modalRef.current.contains(event.target)) {
                onClose();
            }
        };

        document.addEventListener('mousedown', handleClickOutside);

        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onClose]);

    function handleAdd(category, id) {
        dispatch(updateClassSiswa({ category, id }));
        onClose();
    }

    return (
        <div className='bg-modal'>
            <div className='modal-container' ref={modalRef}>
                <h1>Tambah Jabatan</h1>
                <Search
                    placeholder='Jabatan'
                    value={search}
                    onChange={(e) => dispatch(updateStateKelas({ name: 'search', value: e.target.value }))}
                    onKeyDown={() => { }}
                />
                <div className='wrapper-list'>
                    {loadingKelas ? <span>Loading...</span>
                        : searchedKelas.length === 0 ? <span>Jabatan tidak ada</span>
                            :
                            searchedKelas.map((item, index) => (
                                <div className='container-list' key={index} onClick={() => handleAdd(item.category, item.id)}>
                                    <p>{item.category}</p>
                                    <p>+</p>
                                </div>
                            ))
                    }
                </div>
            </div>
        </div>
    )
}

export default ModalRole